import $ from "jquery";

export const getItemCartQuantity = function () {
    return $.ajax({
        type: "GET",
        url: window.localeUrl + "/cart?view=cart-qty",
    });
};
